/*                                                 *\
** ----------------------------------------------- **
**          Calliope - Pixos Game Engine   	       **
** ----------------------------------------------- **
**  Copyright (c) 2020-2022 - Kyle Derby MacInnis  **
**                                                 **
**    Any unauthorized distribution or transfer    **
**       of this work is strictly prohibited.      **
**                                                 **
**               All Rights Reserved.              **
** ----------------------------------------------- **
\*                                                 */

import pixosEngine from "pixos-engine";
let Modules = pixosEngine['pixos-engine'].Modules;

let Resources = Modules.utils.resources;
let Spurt = Modules.sprites.effects.Spurt;
export default class WaterSpurt extends Spurt {
  constructor(engine) {
    // Initialize Sprite
    super(engine);
    this.src = Resources.artResourceUrl("tileset.png");
    this.sheetSize = [512, 512];
    this.tileSize = [16, 16];
    // Frames
    this.frames = {
      up: [
        [0, 448],
        [16, 448],
        [32, 448],
        [48, 448],
        [64, 448],
        [80, 448],
      ],
    };
  }
}
